/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { computeServicesListServiceInstances } from "../../funcs/computeServicesListServiceInstances.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListServiceInstancesRequest$inboundSchema,
};

export const tool$computeServicesListServiceInstances: ToolDefinition<
  typeof args
> = {
  name: "compute-services-list-service-instances",
  description: `List observed service instances`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await computeServicesListServiceInstances(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
